import React, { useEffect, useState } from 'react';
import { getCredits, subscribe, initBilling } from '../api/endpoints';
import type { Credits } from '../types/api';
import { navigateTo } from '../utils/navigation';
import Loading from '../components/Loading';

export default function ProfilePlanPage(): React.JSX.Element {
  const [credits, setCredits] = useState<Credits | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getCredits().then(setCredits).catch(() => { setCredits(null); });
  }, []);

  if (!credits) return <Loading label="Loading plan…" />;

  const handleChange = async () => {
    setBusy(true);
    try {
      await initBilling();
      await subscribe({});
      navigateTo('/profile');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100dvh', background: 'var(--c-cream)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 'var(--s-7) var(--gutter)' }}>
      <div className="stack-5" style={{ width: '100%', maxWidth: '480px' }}>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 var(--s-1)' }}>
          <button
            type="button"
            onClick={() => { navigateTo('/profile'); }}
            className="btn btn--ghost"
            style={{ fontSize: '13px', padding: '10px 18px' }}
          >
            ← Back
          </button>
          <a href="/" className="logo" aria-label="kivo.skin home">
            kivo<span className="dot" />
          </a>
        </div>

        <div className="card card--bordered">
          <p className="t-label" style={{ marginBottom: 'var(--s-3)' }}>Plan</p>
          <h1 className="t-h2" style={{ margin: '0 0 var(--s-5)' }}>
            Change <em className="t-italic t-teal">plan.</em>
          </h1>

          <div className="row-4" style={{ marginBottom: 'var(--s-5)' }}>
            <span className="t-small t-mute">Current plan</span>
            <span className="pill">
              <span className="dot" />
              {credits.plan_name}
            </span>
          </div>

          <div className="row-4" style={{ marginBottom: 'var(--s-6)' }}>
            <span className="t-small t-mute">Credit balance</span>
            <span className="t-small">
              <strong>{credits.total}</strong> total
              <span className="t-mute"> ({credits.monthly_balance} monthly + {credits.surplus_balance} surplus)</span>
            </span>
          </div>

          <hr className="rule" style={{ marginBottom: 'var(--s-6)' }} />

          <div className="row-3" style={{ flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={handleChange}
              disabled={busy}
              className="btn btn--primary"
            >
              {busy ? 'Updating…' : 'Change plan →'}
            </button>
            <button
              type="button"
              onClick={() => { navigateTo('/wallet'); }}
              className="btn btn--ghost"
            >
              Manage credits
            </button>
          </div>
        </div>

        <p className="t-small t-mute" style={{ textAlign: 'center', margin: 0 }}>
          © {new Date().getFullYear()} kivo.skin
        </p>
      </div>
    </div>
  );
}
